import Button from "@components/common/button/Button";
import {Typography, withStyles} from '@material-ui/core';
import * as React from "react";
import TranslateNew from '@translate/TranslateNew';
import {connect} from "react-redux";
import {WithStyles} from "@material-ui/core/styles";
import ProgressBar from "@components/common/progressBar/progressBar";
import {SubscribeStyles} from "@components/onboarding/steps/StepSubscribe/subscribe.styles";
import {ISubscription, SubscriptionPlatform} from "@app-types/websocket/subscription.types";
import {Check} from "@material-ui/icons";
import Subscription from "@components/subscription/Subscription";
import { getOS } from "@helpers/osDetection";

const tn: TranslateNew = TranslateNew.getInstance();

interface ISubscribeProps extends WithStyles<typeof SubscribeStyles> {
    nextStep: (customStep?: number) => void;
    progress?: number | undefined;
    classes: any;
    subscriptions: ISubscription[];
}

class Subscribe extends React.Component<ISubscribeProps> {

    constructor(props: ISubscribeProps) {
        super(props);
    }

    public render() {
        const {classes: style} = this.props;

        let haveTimeLeft = false;
        let beneficiary = "";
        let days = 0;
        for (const sub of this.props.subscriptions) {
            if (sub.platform === SubscriptionPlatform.CAMPAIGN) {
                if ((sub.expirationTime !== undefined && sub.expirationTime > (Date.now() + (1000 * 60 * 60 * 24 * 10)))) {
                    haveTimeLeft = true;
                    beneficiary = sub.name;
                    if (beneficiary === undefined || beneficiary.length === 0) {
                        beneficiary = tn.lang.unknown;
                    }
                    days = Math.ceil((sub.expirationTime - Date.now()) / (1000 * 60 * 60 * 24));
                }
            }
        }

        const os = getOS();

        return (
            <div className={style.root}>
                <div className={style.background}>
                    <div className={style.circle}/>
                </div>
                <div className={style.container}>
                    {this.props.progress && (<div className={style.topBar}>
                        <ProgressBar value={this.props.progress}/>
                    </div>)}

                    {haveTimeLeft ? (
                        <>
                            <div className={style.topContent}>
                                <Typography variant="h2">{tn.lang.onbSubscriptionTitle}</Typography>
                            </div>
                            <div className={style.middleContent}>
                                <Typography>{tn.lang.onbSubscibeBeneficiary(days,beneficiary)}</Typography>
                            </div>
                            <div className={style.bottomContent}>
                                <Button
                                    variant='contained'
                                    color='primary'
                                    size="large"
                                    fullWidth={true}
                                    onClick={() => this.props.nextStep()}>
                                    {tn.lang.great}
                                </Button>
                            </div>
                        </>)
                    :(
                        <>
                            <div className={style.topContent}>
                                <Typography variant="h2">{tn.lang.subscriptionTitle}</Typography>
                            </div>
                            <div className={style.middleContent} style={{gap:0}}>
                                <Subscription isOnboarding={true} callBackSuccess={() => this.props.nextStep()}/>
                            </div>
                            {os === "ANDROID" && false && <div className={style.formBottomContent}>

                                <Button
                                    onClick={() => this.props.nextStep()}
                                    fullWidth={true}
                                >
                                    {tn.lang.skip}
                                </Button>
                            </div>}
                        </>)

                    }
                </div>
            </div>
        );
    }
}

function mapStateToProps(state: any) {
    const subscriptions: ISubscription[] = state.subscriptions.subscriptions;

    return {
        subscriptions
    };
}

export default connect(mapStateToProps)(withStyles(SubscribeStyles)(Subscribe));



// WEBPACK FOOTER //
// ./src/components/onboarding/steps/StepSubscribe/subscribe.component.tsx